import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import api from '../../api/api'

export const get_abandonment_stats = createAsyncThunk(
    'cartAbandonment/get_stats',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/cart-abandonment/stats', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const get_abandonment_logs = createAsyncThunk(
    'cartAbandonment/get_logs',
    async ({ page = 1, limit = 20 }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(`/admin/cart-abandonment/logs?page=${page}&limit=${limit}`, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const get_abandonment_settings = createAsyncThunk(
    'cartAbandonment/get_settings',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get('/admin/cart-abandonment/settings', { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const save_abandonment_settings = createAsyncThunk(
    'cartAbandonment/save_settings',
    async (payload, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.put('/admin/cart-abandonment/settings', payload, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

export const trigger_abandonment_emails = createAsyncThunk(
    'cartAbandonment/trigger',
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/admin/cart-abandonment/trigger', {}, { withCredentials: true })
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response?.data)
        }
    }
)

const cartAbandonmentSlice = createSlice({
    name: 'cartAbandonment',
    initialState: {
        stats: null,
        logs: [],
        totalLogs: 0,
        settings: {
            cart_abandonment_enabled: true,
            cart_abandonment_hours: 24,
            cart_abandonment_cooldown_hours: 48
        },
        triggering: false,
        lastTriggerResult: null,
        successMessage: '',
        errorMessage: ''
    },
    reducers: {
        messageClear: (state) => {
            state.successMessage = ''
            state.errorMessage = ''
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(get_abandonment_stats.fulfilled, (state, { payload }) => {
                state.stats = payload
            })
            .addCase(get_abandonment_logs.fulfilled, (state, { payload }) => {
                state.logs = payload.logs
                state.totalLogs = payload.total
            })
            .addCase(get_abandonment_settings.fulfilled, (state, { payload }) => {
                state.settings = payload.settings
            })
            .addCase(save_abandonment_settings.fulfilled, (state, { payload }) => {
                state.successMessage = payload.message
            })
            .addCase(trigger_abandonment_emails.pending, (state) => {
                state.triggering = true
            })
            .addCase(trigger_abandonment_emails.fulfilled, (state, { payload }) => {
                state.triggering = false
                state.lastTriggerResult = payload
                state.successMessage = payload.skipped
                    ? `Skipped: ${payload.reason}`
                    : `Done — ${payload.emailsSent} email${payload.emailsSent !== 1 ? 's' : ''} sent`
            })
            .addCase(trigger_abandonment_emails.rejected, (state, { payload }) => {
                state.triggering = false
                state.errorMessage = payload?.error || 'Trigger failed'
            })
            .addMatcher(
                (action) => action.type.startsWith('cartAbandonment/') && action.type.endsWith('/rejected'),
                (state, { payload }) => {
                    state.errorMessage = payload?.error || 'Something went wrong'
                }
            )
    }
})

export const { messageClear } = cartAbandonmentSlice.actions
export default cartAbandonmentSlice.reducer
